// extracted by mini-css-extract-plugin
module.exports = {"HeroContainer":"_3tUtw8VTpIUFaBHMCT223B"};